import { StoreManagementCreateItemRequest } from "@/common/api";

export enum STATUS {
  EDIT = "edit",
  WAIT = "wait",
  RELEASE = "release",
  NO_RELEASE = "no_release",
  CANCEL = "cancel",
  SEND = "send",
}

export const STATUS_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAIT]: "公開待ち",
  [STATUS.RELEASE]: "公開中",
  [STATUS.NO_RELEASE]: "非公開",
};

export const STATUS_NAME_INPUT = {
  [STATUS.EDIT]: "編集中",
  [STATUS.RELEASE]: "公開",
  [STATUS.NO_RELEASE]: "非公開",
  [STATUS.CANCEL]: "中止",
  [STATUS.SEND]: "送信",
};

export const STATUS_CSS = {
  [STATUS.EDIT]: "editing",
  [STATUS.WAIT]: "wait",
  [STATUS.RELEASE]: "release",
  [STATUS.NO_RELEASE]: "no_release",
  [STATUS.CANCEL]: "cancel",
};

export const STATUS_ARRAY = [
  { id: STATUS.EDIT, name: STATUS_NAME[STATUS.EDIT] },
  { id: STATUS.WAIT, name: STATUS_NAME[STATUS.WAIT] },
  { id: STATUS.RELEASE, name: STATUS_NAME[STATUS.RELEASE] },
  { id: STATUS.NO_RELEASE, name: STATUS_NAME[STATUS.NO_RELEASE] },
];

export const STATUS_ARRAY_INPUT = [
  { id: STATUS.EDIT, name: STATUS_NAME_INPUT[STATUS.EDIT] },
  { id: STATUS.RELEASE, name: STATUS_NAME_INPUT[STATUS.RELEASE] },
  { id: STATUS.NO_RELEASE, name: STATUS_NAME_INPUT[STATUS.NO_RELEASE] },
];

export const STATUS_LIVE = [
  { id: STATUS.EDIT, name: STATUS_NAME_INPUT[STATUS.EDIT] },
  { id: STATUS.RELEASE, name: STATUS_NAME_INPUT[STATUS.RELEASE] },
  { id: STATUS.CANCEL, name: STATUS_NAME_INPUT[STATUS.CANCEL] },
];

export const STATUS_SEND_MAIL = [
  { id: STATUS.EDIT, name: STATUS_NAME_INPUT[STATUS.EDIT] },
  { id: STATUS.SEND, name: STATUS_NAME_INPUT[STATUS.SEND] },
];

export const STATUS_STORE = [
  { id: StoreManagementCreateItemRequest.openStatus.HOLD, name: "保留" },
  { id: StoreManagementCreateItemRequest.openStatus.RELEASE, name: "有効" },
  { id: StoreManagementCreateItemRequest.openStatus.NO_RELEASE, name: "無効" },
];

export enum SETTING {
  NOW = "now",
  DATE = "date",
}

export const SETTING_NAME = {
  [SETTING.NOW]: "今すぐ公開",
  [SETTING.DATE]: "日時指定",
};
